import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import Modalizer from 'components/modalizer/modalizer'
import View from 'views/paywalls/google_slides_unauthorized_create_view'

class GoogleSlidesUnauthorizedCreateModal extends PureComponent {

	render() {
		return (
			<Modalizer
				width='436px'
				closeAction={this.props.handleCloseConfirm}
				nopadding
			>
				<View
					handleUpgrade={this.props.handleUpgrade}
					upgradeCode={this.props.upgradeCode}
				/>
			</Modalizer>
		)
	}
}

GoogleSlidesUnauthorizedCreateModal.propTypes = {
	handleUpgrade: PropTypes.func.isRequired,
	handleCloseConfirm: PropTypes.func.isRequired,
	upgradeCode: PropTypes.string.isRequired,
}

export default GoogleSlidesUnauthorizedCreateModal
